<template>
  <div>
    <a
      style="width: 295px"
      class="btn btn-success btn-md"
      data-target="#modalAddProductoPrecio"
      data-toggle="modal"
      href="#"
    >
      <span> Crear contenedor &nbsp; <i class="fas fa-plus"></i></span>
    </a>
    <div
      aria-hidden="true"
      class="onboarding-modal modal fade animated"
      id="modalAddProductoPrecio"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog modal-md" role="document">
        <div class="modal-content text-center">
          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
            <span class="close-label">Cancelar</span>
            <span class="os-icon os-icon-close"></span>
          </button>
          <div class="onboarding">
            <div class="onboarding-content with-gradient">
              <div class="text-center">
                <h5 class="onboarding-title text-center">Asignación de contenedor</h5>
              </div>
              <form @submit="crearContenedor">
                <div class="row">
                  <div class="col-12">
                    <div class="form-group">
                      <label>Tienda origen</label>
                      <div class="input-group">
                        <select
                          class="form-control"
                          autofocus="autofocus"
                          required
                          v-model="current.tienda_origen"
                        >
                          <option value="">Seleccione una tienda</option>
                          <option
                            v-for="(tienda, key) in tiendas"
                            :value="tienda"
                            :key="key"
                          >
                            {{ tienda.codigo }}
                            -
                            {{ tienda.nombre }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="form-group">
                      <label>Tienda destino</label>
                      <div class="input-group">
                        <select
                          class="form-control"
                          autofocus="autofocus"
                          required
                          v-model="current.tienda_destino"
                        >
                          <option value="">Seleccione una tienda</option>
                          <option
                            v-for="(tienda, key) in tiendas"
                            :value="tienda"
                            :key="key"
                          >
                            {{ tienda.codigo }}
                            -
                            {{ tienda.nombre }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <label
                        v-bind:class="{
                          'text-danger':
                            current.errors.activo_fijo &&
                            current.errors.activo_fijo.length > 0,
                        }"
                        >Vehículo</label
                      >
                      <div class="input-group">
                        <select
                          class="form-control"
                          autofocus="autofocus"
                          v-model="current.activo_fijo"
                          @input="$emit('input', $event.target.value)"
                        >
                          <option
                            v-for="(af, key) in activos_fijos"
                            :value="af"
                            :key="key"
                          >
                            {{ af.placa }} {{ af.nombre }} ({{ af.identificador }})
                          </option>
                        </select>
                        <small
                          v-if="current.errors && current.errors.activo_fijo"
                          class="form-text text-danger"
                          >{{ current.errors.activo_fijo[0] }}</small
                        >
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-12">
                    <div class="form-group">
                      <label for>Encargado</label>
                      <div class="input-group">
                        <input
                          type="text"
                          class="form-control"
                          v-model="current.usuario.username"
                          :disabled="true"
                        />
                      </div>
                    </div>
                  </div>
                  <PilotoSelectComponent
                    class="col-sm-12 form-control-md"
                    titulo="Nombre de Piloto"
                    style="display: block"
                    :current="current_"
                  />
                  <div class="col-sm-12" v-if="current.activo_fijo == null">
                    <div class="form-group">
                      <label for>Matricula</label>
                      <div class="input-group">
                        <input
                          v-model="current.matricula"
                          class="form-control"
                          placeholder="#"
                          type="text"
                        />
                      </div>
                      <small
                        v-if="current.errors && current.errors.matricula"
                        class="form-text text-danger"
                        >{{ current.errors.matricula }}</small
                      >
                    </div>
                  </div>
                </div>
                <div class="modal-footer">
                  <button class="btn btn-primary" type="submit">Agregar</button>
                  <button
                    class="btn btn-secondary"
                    ref="cerrarModal"
                    data-dismiss="modal"
                    type="button"
                  >
                    Cerrar
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DynamicService from "@/services/commons/DynamicService";
import Notifications from "@/notifications/notifications";
import ContenedorService from "@/services/wms/ContenedorService";
import PilotoSelectComponent from "@/components/commons/PilotoSelectComponent";
import { mapGetters } from "vuex";

export default {
  components: { PilotoSelectComponent },
  data() {
    return {
      tiendas: "",
      encargado: [],
      current_: {
        estado: 'A',
      },
      current: {
        tienda: null,
        activo_fijo: null,
        piloto: "",
        matricula: "",
        usuario: "",
        tienda_origen: null,
        tienda_destino: null,
        encargado: null,
        activo_fijo: null,

        errors: {},
      },
      activos_fijos: [],
    };
  },
  watch: {},
  computed: {
    ...mapGetters({
      rutas: "recepciones/rutas",
    }),
    unidad_medida() {
      this.refrescarPrecioVenta();
      return this.current.unidad_medida;
    },
  },
  mounted() {
    let self = this;
    this.$store.dispatch("recepciones/rutas", {
      activa: true,
      quitar_paginacion: true,
    });
    self.refreshActivosFijos();
    self.autoUser();
    self.refreshTienda();
  },
  methods: {
    refreshTienda() {
      let self = this;
      DynamicService.fetch("cat", "tiendas", {
        quitar_paginacion: true,
      }).then((response) => {
        self.tiendas = response.data;
      });
    },
    autoUser() {
      let self = this;
      DynamicService.getActionList("accounts", "usuarios", "profile").then((response) => {
        self.current.usuario = response.data;
      });
    },
    refreshActivosFijos() {
      let self = this;
      DynamicService.fetch("af", "activo", {
        quitar_paginacion: true,
      }).then((res) => {
        self.activos_fijos = res.data;
      });
    },
    alertActivoFijo() {
      var mensaje;
      var opcion = confirm("¿Elegir un activo Fijo?");
      if (opcion == true) {
        $("#modalAddActivo").modal();
      } else {
        $("#modalAddProductoPrecio").modal();
      }
    },
    cerrandoModal() {
      this.$emit("cerrandomodal");
    },
    crearContenedor(e) {
      let self = this;
      e.preventDefault();
      var _current = Object.assign({}, this.current);
      _current.tienda_origen = self.current.tienda_origen.codigo;
      _current.tienda_destino = self.current.tienda_destino.codigo;
      if (self.current_.piloto) {
        _current.piloto = self.current_.piloto.usuario.username;
      }
      if (self.current.usuario) {
        _current.encargado = self.current.usuario.id;
      }
      if (self.current.activo_fijo) {
        _current.activo_fijo = self.current.activo_fijo.id;
        _current.matricula = self.current.activo_fijo.placa;
      }
      ContenedorService.save(_current)
        .then((res) => {
          self.current.errors = {};
          $("#modalAddProductoPrecio").modal("hide");
          Notifications.alert.success("Contenedor", "Se ha agregado un nuevo contenedor");
          Vue.nextTick(function () {
            self.$router.push({
              name: "wms-contenedor-editar",
              params: { id: res.data.id },
            });
          });
        })
        .catch((error) => {
          console.log(error.response.data);
          Vue.nextTick(function () {
            self.current.errors = Object.assign({}, error.response.data);
            if ("detail" in error.response.data) {
              Notifications.alert.error(
                "No se pudo crear el contenedor:",
                error.response.data.detail
              );
            }
          });
        });
    },
  },
};
</script>
